import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/arrowHorizontal.tsx
var ArrowHorizontal = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M18.5 8L21.7929 11.2929C22.1834 11.6834 22.1834 12.3166 21.7929 12.7071L18.5 16M5.49997 8L2.20708 11.2929C1.81655 11.6834 1.81655 12.3166 2.20708 12.7071L5.49997 16M2.49997 12H21.5",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M18.5 8L21.7929 11.2929C22.1834 11.6834 22.1834 12.3166 21.7929 12.7071L18.5 16M5.49997 8L2.20708 11.2929C1.81655 11.6834 1.81655 12.3166 2.20708 12.7071L5.49997 16M2.49997 12H21.5",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
//#endregion
export { ArrowHorizontal };
